export const defaultContext = {
  stake: '0.00',
  baseStake: '0.00',
  sliderValue: '50',
  rollUnder: '0',
  manualConfigs: {
    stake: '0.00',
    sliderValue: '50.00',
    rollUnder: '0',
  },
  config: {
    minbet: 0,
    maxbet: 100,
  },
  auth: {
    balance: { amount: '', currency: '' },
    casino_id: '',
    currency_id: '',
    game_id: '',
    ip: '',
    login_params: '',
    player_id: '',
    player_name: '',
    provider_id: '',
    session_id: '',
  },
  settings: {
    stake: '',
    bankroll: '50',
    rake: 1,
    over_or_under: '0',
    audio: { isMusicOff: false, isSoundOff: false, music: '50', sound: '50' }
  },
  autoConfigOne: {
    stake: '',
    rollAmount: '',
    onWin: true,
    onWinPercent: '',
    onLoss: true,
    onLossPercent: '',
    stopOnLoss: '',
    stopOnWin: '',
    maxStake: '',
    rollNumber: '',
    rollUnder: '',
    isSaved: '0',
  },
  autoConfigTwo: {
    stake: '',
    rollAmount: '',
    onWin: true,
    onWinPercent: '',
    onLoss: true,
    onLossPercent: '',
    stopOnLoss: '',
    stopOnWin: '',
    maxStake: '',
    rollNumber: '',
    rollUnder: '',
    isSaved: '0',
  },
  autoConfigThree: {
    stake: '',
    rollAmount: '',
    onWin: true,
    onWinPercent: '',
    onLoss: true,
    onLossPercent: '',
    stopOnLoss: '',
    stopOnWin: '',
    maxStake: '',
    rollNumber: '',
    rollUnder: '',
    isSaved: '0',
  },
  activeConfig: 1,
  handleRollUnderValue: () => { return },
  handleSliderValueCTX: () => { return },
  handleAutoConfigCTX: () => { return },
  handleManualConfigs: () => { return },
  handleBaseStakeHelper: () => { return },
  handleStake: () => { return },
  bet: {
    win: 0,
    profit: 0,
    bet_id: ''
  },
  seeds: {
    client_seed: '',
    server_seed_SHA256: '',
    next_server_seed_SHA256: '',
    nonce: 0,
    old_client_seed: '',
    old_server_seed: '',
    old_server_seed_SHA256: '',
    old_nonce: 0,
  },
  // gameInfo: {
  //   user_name: '',
  //   user_id: '',
  //   currency: 'USD',
  //   balance: '',
  //   toFix: 2,
  //   maxBet: '300',
  //   minBet: '',

  //   serverSeedSHA256: '',
  //   clientSeed: '',
  //   nonce: 0,
  //   next_server_seed_SHA256: '',
  // },
  isError: false,
  errorText: '',
  diceSocketMessages: null,
  globalSocketMessages: null,
  history: {
    my: [],
    all: [],
    high: [],
  }
}
